export default __webpack_public_path__ + "static/kurorty-img-2-0e73c0bfcc717910224a8f27dc9193c5.png";